/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import DetectAmp from 'components/DetectAmp';
import adInjector from 'util/ads/injector';
import { SITE_KEY } from 'constants/site';
import { getIsoDate } from 'oxygen-lib-ui/helpers/date';
import memoize from 'memoize-one';
import { HAS_ADS } from 'constants/site';

export default WrappedComponent => {
  class WithAds extends Component {
    injectAds = memoize((_bundles, _type, _isAmp) =>
      adInjector(_bundles || [], _type, _isAmp)
    );
    render() {
      const { pageType } = this.props;
      if (HAS_ADS === false) {
        // Ads are disabled for this site
        return <WrappedComponent {...this.props} />;
      }
      return (
        <DetectAmp>
          {isAmp => {
            const { contentBundles, ...rest } = this.props;
            let injected;

            if (contentBundles) {
              injected = this.injectAds(contentBundles, pageType, isAmp);
            }

            // THIS IS A TEST FOR THE JW ARTICLE MATCHING ON AT DESKTOP
            // Please see https://app.asana.com/0/1162735860823529/1199643526211805/f
            if (pageType === 'post' && SITE_KEY === 'at' && isAmp === false) {
              const post = injected && injected[0];
              const hasEmbeddedVideo =
                post &&
                post.items.find(item => item.type === 'video') !== undefined;
              const category =
                post && post.data.categories
                  ? post.data.categories[0]
                  : undefined;
              const publishDateYear =
                post && post.data.publishedAt
                  ? new Date(getIsoDate(post.data.publishedAt)).getFullYear()
                  : undefined;
              const isSponsoredPost = post && post.hideAds;

              if (
                !isSponsoredPost &&
                !hasEmbeddedVideo &&
                publishDateYear === 2020 &&
                category.slug === 'organizing-cleaning'
              ) {
                // index in post items before second to last paragraph
                const paragraphItems = post.items.filter(
                  e => e.type === 'html'
                );
                const beforeSecondToLastParagraph = post.items.indexOf(
                  paragraphItems[paragraphItems.length - 2]
                );
                // insert new video ad before html block
                post.items = [
                  ...post.items.slice(0, beforeSecondToLastParagraph),
                  {
                    id: 'video-interrupter-desktop',
                    type: 'inPostVideoAdDesktop',
                    data: {
                      playlist:
                        'https://cdn.jwplayer.com/v2/playlists/S9fE7x1u?search=__CONTEXTUAL__',
                      placement: 'related',
                      showTitle: true
                    }
                  },
                  ...post.items.slice(beforeSecondToLastParagraph)
                ];
                post.aside =
                  post &&
                  post.aside &&
                  post.aside.filter(item => item.id !== 'video-right-rail');
              }
            }
            return <WrappedComponent contentBundles={injected} {...rest} />;
          }}
        </DetectAmp>
      );
    }
  }
  return WithAds;
};
